<dx-stepper [class.label-only]="labelOnly"
            [items]="steps"
            [selectedIndex]="currentStepIdx"
            [linear]="false"
            [disabled]="disabled"
            (onSelectionChanging)="onSelectionChanging($event)">
    @if (labelOnly) {
        <div *dxTemplate="let data of 'item'">
            <div class="dx-step-caption">
                <div class="dx-step-label">{{ data.label }}</div>
            </div>
        </div>
    }
</dx-stepper>
